import { useHistory } from 'react-router-dom'
import { MuseLogo } from '@/components/MuseLogo'
import { motion } from 'framer-motion'
import * as Constants from '../../services/Constants'
import { useTranslation } from 'react-i18next'
import { Button } from '@/UIComponents2/Button'
import RightArrowIcon from '@/CustomIcons/RightArrowIcon'
import UnauthorizedPageBase from './UnauthorizedPageBase'

function PasswordResetResultPage() {
    const history = useHistory()
    const { t } = useTranslation()
    const urlParams = new URLSearchParams(history.location.search)
    const resetEmail = urlParams.get('email') || ''

    return (
        <UnauthorizedPageBase>
            <div className="w-full h-[24px]">
                <div className="w-[108px] h-[24px] mb-8">
                    <MuseLogo />
                </div>
            </div>
            <motion.div
                key="password-reset-result"
                className="flex flex-col gap-[48px] justify-center h-full"
                initial={{ x: 50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: -50, opacity: 0 }}
                transition={{
                    duration: 0.3,
                    ease: 'easeOut',
                }}
            >
                <div className="flex flex-col gap-[14px] items-start">
                    <span className="max-w-[442px] text-[30px]/[30px] font-[500] bg-linear-[98deg,white_21.88%,transparent_139.38%] bg-clip-text text-transparent">
                        Reset email sent!
                    </span>
                    <span className="w-auto text-lg text-[rgba(255,255,255,0.75)]">
                        We sent an email containing the password reset link to{' '}
                        <span className="text-[#FCE640]">{resetEmail}</span>.
                    </span>
                    <span className="w-auto text-lg text-[rgba(255,255,255,0.75)]">
                        If you do not receive the email within an hour, please check for typos and try again, or contact
                        us at <span className="text-[#FCE640]">{Constants.support_email}</span>.
                    </span>
                </div>
                <Button className="w-full relative" variant="primary" onClick={() => history.push('/login')}>
                    {t('Back to login')}
                    <RightArrowIcon className="absolute right-4" />
                </Button>
            </motion.div>
        </UnauthorizedPageBase>
    )
}

export default PasswordResetResultPage
